<template>
  <a v-if="rights.includes('payments') && !isPatient"
     @click="pay"
     class="pointer">
    <DollarSvg class="svg-light"/>
  </a>
</template>

<script setup>
import { useStore} from "vuex"
import DollarSvg from '@/assets/svg-vue/patients/dollar.svg'
import {computed, getCurrentInstance, nextTick, onBeforeMount} from "vue"
import {copyObject} from "@/extensions/prototypes/prototypes"

const props = defineProps({
  object: {
    type: Object
  }
})

let bvModal = null
const store = useStore()

const rights = computed(() => store.state.auth.rights)
const getters = store.getters
const isPatient = computed(() => getters.isPatient)

const pay = async () => {
  store.commit('setPatient', copyObject(props.object))
  await nextTick()
  bvModal.show('patient-topay-modal')
}

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
})
</script>
